/**
 * product-item-template for AJAX requests
 * @param {Object}			item - product object from shop response
 * @param {boolean}			available - product availability
 * @param {boolean}			vendor_varies - if true - check logo height
 */
function product_item_template(item, available, label_add, label_select, label_details, vendor_varies) {

    var content =   '<div class="product col-sm-4 product_collection ' + item.cycle + '">'+
                        '<div class="product_wrapper">'+
                            '<div class="product_img">'+
                                '<a class="img_change" href="' + item.url + '">'+
                                    '<img src="' + item.image + '">'+
                                    '<img class="img__2" src="' + item.image2 + '">'+
                                '</a>'+
                            '</div>'+
                            '<div name="' + item.cycle_name + '" class="product_info ' + item.cycle + '">'+
                                '<div class="logo_brand">'+
                                    '<img name="height_logo" src="' + item.logo + '" class="hide" onload="scale_width(this, ' + vendor_varies + ')">'+
                                '</div>'+
                                '<div class="product_price">'+
                                    '<span class="money">' + item.price + ' *</span>'+
                                '</div>'+
                                '<div>'+
                                    '<span name="height_bp" class="right" ' + (item.baseprice ? '>'+item.baseprice : 'style="visibility: hidden;">&nbsp;') + '</span>'+
                                '</div>'+
                                '<div name="height_text">'+
                                    '<div class="product_name">'+
                                        '<a href="' + item.url + '">' + item.title + '</a>'+
                                    '</div>'+
                                    '<div class="product_desc product_desc_short">' + item.desc_short + '</div>'+
                                '</div>'+
                                '<div class="product_desc product_desc_long">' + item.desc_long + '</div>'+
                                '<div class="product_links">'+
                                    '<form method="post" action="/cart/add">';
    if(available) {
        if(item.size==1) {
            content +=                  '<input type="hidden" name="id" value="' + item.varid + '" />';

            if(item.desc_long.startsWith("Geschenkset von")) {
                var arr_desc = item.desc_long.split(":");
                var desc_val = item.desc_long.replace(arr_desc[0]+":", "").replace("<br />-", "").replaceAll("<br />-", "&");

                content +=              '<input type="hidden" id="PropSet" name="properties[Geschenkset]" value="' + desc_val.trim() + '">';
            } else {
                content +=              (item.baseprice ? '<input type="hidden" id="Prop" name="properties[_baseprice]" value="' + item.baseprice + '">' : '')+
                                        (item.baseprice ? '<input type="hidden" id="Prop2" name="properties[Grundpreis]" value="' + item.baseprice + '">' : '')+
                                        (item.baseprice ? '<input type="hidden" id="PropSize" name="properties[_basepriceSize]" value="' + item.basepriceSize + '">' : '')+
                                        (item.baseprice ? '<input type="hidden" id="PropUnit" name="properties[_basepriceUnit]" value="' + item.basepriceUnit + '">' : '');
            }
            
            content +=                  '<input type="hidden" name="attributes[locale]" value="' + lang + '">'+
                                        '<button class="btn btn-cart" type="submit" title="' + label_add + '"><i class="fa fa-shopping-cart"></i></button>';
        } else {
            content +=                  '<a class="btn" href="' + item.url +'" title="' + label_select + '"><i class="fa fa-bars"></i></a>';
        }
    } else {
            content +=                   '<button class="btn btn-cart btn-disabled" disabled="disabled"><i class="fa fa-ban"></i></button>';
    }
    content +=                      '</form>'+
                                    '<a class="btn" href="' + item.url + '" title="' + label_details + '"><i class="fa fa-info"></i></a>'+
                                '</div>'+
                            '</div>'+
                            '<div class="clearfix"></div>'+
                        '</div>'+
                    '</div>';

	return content;
}

/**
 * After collection load
 * check height of logo, baseprice and text
 * adjust to equal heights
 * @param {boolean}			baseprice     - show/hide? - BP check happens on collection load
 */
function check_height(baseprice) {
    // reset style 'height'
    $('#p_content .product_info [name="height_text"]').removeAttr("style");

    $('.product_info.item3_1').each(function(index, obj) {
        let name = this.getAttribute('name');
        let elmts = document.getElementsByName(name);
        let len = elmts.length;

        /************ Baseprice ************/
        if(baseprice) {
            let _bp=0;
            let first_bp=elmts[0].querySelector('[name="height_bp"]'), second_bp, third_bp;
            if(getComputedStyle(first_bp).visibility=="hidden") { _bp++; }
            if(len>1) {
                second_bp=elmts[1].querySelector('[name="height_bp"]');
                if(getComputedStyle(second_bp).visibility=="hidden") { _bp++; } }
            if(len>2) {
                third_bp=elmts[2].querySelector('[name="height_bp"]');
                if(getComputedStyle(third_bp).visibility=="hidden") {_bp++; } }
            
            if(len==_bp) {
                $(first_bp).remove();
                if(second_bp) { $(second_bp).remove(); }
                if(third_bp) { $(third_bp).remove(); }
            }
        }

        /************ Desc ************/        
        let first = elmts[0].querySelector('[name="height_text"]').clientHeight;
        let second=0;
        if(len>1) { second = elmts[1].querySelector('[name="height_text"]').clientHeight; }
        let third=0;
        if(len>2) { third = elmts[2].querySelector('[name="height_text"]').clientHeight; }
        
        let max = Math.max(first, second, third);
        if(max>0) { $(elmts).children('[name="height_text"]').height(max); }

        /************ Logo ************/
        let firstLogo = elmts[0].querySelector('.logo_brand').clientHeight;
        let secondLogo = 0;
        if(len>1) { secondLogo = elmts[1].querySelector('.logo_brand').clientHeight; }
        let thirdLogo=0;
        if(len>2) { thirdLogo = elmts[2].querySelector('.logo_brand').clientHeight; }
        
        let maxLogo = Math.max(firstLogo, secondLogo, thirdLogo);
        if(maxLogo>0) { $(elmts).children('.logo_brand').height(maxLogo); }
    });
}

function check_logo_height() {
    $('#p_content .product_info .logo_brand').removeAttr("style");
    $('.product_info.item3_1').each(function(index, obj) {
        let name = this.getAttribute('name');
        let elmts = document.getElementsByName(name);
        let len = elmts.length;
        
        /************ Logo ************/
        
        let first_logo = elmts[0].querySelector('[name="height_logo"]').clientHeight;
        let second_logo=0;
        if(len>1) {
            second_logo = elmts[1].querySelector('[name="height_logo"]').clientHeight;
        }
        let third_logo=0;
        if(len>2) {
            third_logo = elmts[2].querySelector('[name="height_logo"]').clientHeight;
        }
        
        let max_logo = Math.max(first_logo, second_logo, third_logo);
        if(max_logo>0) { $(elmts).children('.logo_brand').height(max_logo); }
    });
}

/*
 * Load collection items
 * VIEW: collection.jsonx.liquid
 * This function filters available items | Filter delivered within function-call in URL
 */
function loadCollection(coll_json) {
    $('#p_content').empty();
    $("#product_listing_preloader").fadeIn(600),$('#collection_sorted').hide();

    let vendor_varies;
	var collection_results = $.get(
		coll_json,
		function(data) {
            let response = $.parseJSON(data);
            let label_add = response.label_add;
            let label_select = response.label_select;
            let label_details = response.label_details;
            vendor_varies = response.vendor_varies;
            
            if(response.count_view) {
                $('#count_view').html(response.count_view);
            }
            if(response.page_links) {
                $('#pagination').html(response.page_links);
            }

			// Iterate through filtered response
            let p_content = $('#p_content');
			$(response.results).each(function(index, item) {
                p_content.append(product_item_template(item, this.availability, label_add, label_select, label_details, vendor_varies));
			});
        }
	)
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.warn("ajax failed: " + errorThrown);
    })
    .always(function() {
        $("#product_listing_preloader").fadeOut(300),$('#collection_sorted').show();
        check_height(true);
    });
}

// Logos
function scale_height(img) {
    var height = img.height;
    if(!height) { height = '80'; } // %
    $(img).css('height', height + '%').addClass("scale-height").removeClass('hide');
}

function scale_width(img, vendor_varies) {
    let width = img.width;
    width = (width / 400) * 100;
    $(img).css('width', width + '%').addClass("scale-width").removeClass('hide');

    let not_loaded = $('[name="height_logo"]:hidden');
    if(not_loaded.length == 0) {
        if(vendor_varies) {
            check_logo_height();
        }
    }
}

function scale_width_index(img) {
    let width = img.naturalWidth;
    width = (width / 400) * 100;
    $(img).css('width', width + '%').addClass("scale-width").removeClass('hide');

    let not_loaded = $('[name="height_logo"]:hidden');
    if(not_loaded.length == 0) {
        setTimeout(function(){
            scale_width_index_responsive();
        }, 1000);
    }
}

function scale_width_index_responsive() {
    $('[name="height_logo"]').parent().css('height', 'unset').height('unset');
    let height_logo = $('[name="height_logo"]');
    let __arr = [];
    $(height_logo).each(function() {
        __arr.push(this.clientHeight);
    });
    let max_logo = Math.max.apply(null, __arr);
    if(max_logo > 0) { $(height_logo).parent().height(max_logo); }
}

function set_height_index(baseprice) {
    $('[name="height_text"]').css('height', 'unset').height('unset');
	
	let elmts = document.getElementsByName('refname_1');
	let len = elmts.length;

	if(baseprice) {
		/************ Baseprice ************/
		let _bp=0;
		let height_bp = $('[name="height_bp"]');
		$(height_bp).each(function() {
			if(getComputedStyle(this).visibility=="hidden") { _bp++; }
		});
		if(len == _bp) { $(height_bp).remove(); }
	}

	/************ Desc ************/
	let height_text = $('[name="height_text"]');
	let _arr = [];
	$(height_text).each(function() {
		_arr.push(this.clientHeight);
	});
	let max_desc = Math.max.apply(null, _arr);
	if(max_desc) { $(height_text).height(max_desc); }
}

$(function () {
    var url = window.location.href;

    if (url.indexOf("/search?q=")>-1 && url.indexOf("type=")==-1){
        // Encode URL params as we have Products with '&'. etc. (same in autocomplete)
        location.assign(url + "&type=product");
    }

    /*$('#cart_content .cart_item').each(function(index) {
        let baseprice = $(this).data('bp');
        if(index > 0) { baseprice = ", " + baseprice; }
        
		if(baseprice) {
			$('#footnote').removeClass('hide').append(baseprice);
		}
    });*/
});